import { render, staticRenderFns } from "./YSwitch.vue?vue&type=template&id=0578538e&scoped=true&lang=pug&"
import script from "./YSwitch.vue?vue&type=script&lang=js&"
export * from "./YSwitch.vue?vue&type=script&lang=js&"
import style0 from "./YSwitch.vue?vue&type=style&index=0&id=0578538e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578538e",
  null
  
)

export default component.exports